.wrap {
  min-width: 0;
}

.rows {
  display: grid;
  gap: 0;
}

.item {
  display: grid;
  gap: 2px;
}

.row {
  display: grid;
  grid-template-columns: minmax(88px, 36%) 1fr auto;
  align-items: center;
  gap: 10px;
  /* 24px: a row that opens a receipt is a pointer target (WCAG 2.5.8). */
  min-height: 24px;
  padding: 1px 6px;
  border-radius: var(--radius-ctl);
  color: var(--ink-2);
  font-size: var(--t-min);
  outline: none;
  transition:
    opacity var(--dur-1) var(--ease-std),
    background var(--dur-1) var(--ease-std);
}

.row:hover,
.row:focus-visible {
  background: var(--panel-2);
}

.row:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 1px;
}

.dim {
  opacity: 0.5;
}

.openable {
  cursor: pointer;
}

.name {
  display: block;
  min-width: 0;
  color: var(--ink);
}

/* A name wraps to a second line before it is cut: "Long Beach Dist..." named no site (G-Wviewer-25). */
.nameText {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.sub {
  display: block;
  overflow: hidden;
  color: var(--muted);
  font-size: var(--t-min);
  text-overflow: ellipsis;
}

.track {
  position: relative;
  display: flex;
  align-items: center;
  height: 10px;
  border-radius: 5px;
  background: var(--panel-3);
  overflow: hidden;
}

.centre {
  justify-content: center;
}

.fill {
  display: block;
  height: 100%;
  min-width: 2px;
  border-radius: 6px;
}

/* A bar of parts (a site's scopes): the same length as a plain bar, split by each part's share, with a
 * 1px surface gap so neighbours are told apart by more than hue. */
.stack {
  display: flex;
  height: 100%;
  min-width: 2px;
  gap: 1px;
  border-radius: 6px;
  overflow: hidden;
}

.part {
  display: block;
  min-width: 2px;
  flex-basis: 0;
}

/* "Not assessed": a hatched, dashed-outline bar with no length. A pattern, not a short bar. */
.hatch {
  display: block;
  width: 100%;
  height: 100%;
  border: 1px dashed var(--muted);
  border-radius: 6px;
  background: repeating-linear-gradient(135deg, var(--line-2) 0 2px, transparent 2px 7px);
  box-sizing: border-box;
}

.value {
  min-width: 48px;
  color: var(--ink);
  font-weight: 650;
  text-align: right;
  white-space: nowrap;
}

.words {
  color: var(--muted);
  font-weight: 400;
}

/* A funnel's step between two rows: small, muted, aligned under the bars. */
.between {
  padding-left: 6px;
  color: var(--muted);
  font-size: var(--t-min);
}

.tipLine {
  display: block;
  font-variant-numeric: lining-nums tabular-nums;
}

@media (prefers-reduced-motion: reduce) {
  .row {
    transition: none;
  }
}

/* What the list left out, with its link: one muted line under the bars. */
.footer {
  padding: 6px 6px 0;
  color: var(--muted);
  font-size: var(--t-min);
}
